/**
 * ═══════════════════════════════════════════════════════════════════════
 *  PERIODISMOSINT i18n ENGINE v1.0.0
 *  Client-side bilingual translation system (ES ↔ EN)
 *  Lightweight, zero-dependency, instant switching
 * ═══════════════════════════════════════════════════════════════════════
 */
(function() {
    'use strict';

    // ── TRANSLATION DICTIONARY ──────────────────────────────────────────
    var PSINT_DICT = {
        'tag.eyebrow.default': 'PUBLICATIONS',
        'tag.eyebrow.news': 'NEWS',
        'tag.eyebrow.lab': 'DATA LAB',
        'archive.hero.eyebrow': 'ALL PUBLICATIONS',
        'archive.hero.title': 'Archive',
        'archive.hero.desc': 'All Periodismosint publications',
        'archive.filter.all': 'All',
        'lernent.empty.badge': '// UNIT IN DEPLOYMENT',
        'lernent.empty.title': 'Territorial Dockets in Audit',
        'lernent.empty.desc': 'Satellite and notarial forensic investigations with the <strong>#lernent</strong> badge are currently in reporting and cadastral data verification.',
        'lernent.empty.f1': 'Notarial deeds &amp; public land audits',
        'lernent.empty.f2': 'Sentinel-2 multitemporal satellite mapping',
        'lernent.empty.f3': 'Corporate beneficial ownership cross-referencing',
        'lernent.empty.cta': 'Send Lead or Secure Document &rarr;',
        'about.allies.independent': 'INDEPENDENT OUTLET',
        'about.allies.data_osint': 'INVESTIGATION &amp; DATA',
        'about.allies.tech_eco': 'OSINT INTELLIGENCE',
        'about.allies.tech_ecosystem': 'TECHNOLOGICAL ECOSYSTEM',
        'about.allies.regional': 'REGIONAL OUTLET',

        // ═══════════ NAVIGATION ═══════════
        'nav.home': 'Home',
        'nav.news': 'News',
        'nav.lab': 'OSINT Lab',
        'nav.artivismo': 'Artivism',
        'nav.lernent': 'Lernent',
        'artiv.dock.badge': 'AFINIDADES × ARTIVISM',
        'artiv.dock.nav1': 'TED Context',
        'artiv.dock.nav2': 'Néstor Keynote (12 Slides)',
        'artiv.dock.nav3': 'Covers &amp; Videos',
        'artiv.dock.nav4': 'Afinidades Exhibition',
        'artiv.dock.autoplay': 'Auto-Play',
        'artiv.dock.notes': 'Speaker Notes',
        'artiv.dock.project': 'Project (F)',
        'artiv.ted.badge': 'AFINIDADES EXHIBITION · CASA QUANTUM GALLERY × PERIODISMOSINT',
        'artiv.ted.meta': 'PRELUDE &amp; CONCEPTUAL CONTEXT · MEDELLÍN, 2026',
        'artiv.ted.title': 'Art as <span>Memory Technology</span> and Trigger of Truth.',
        'artiv.ted.lead': 'Before entering Néstor Espinosa Robledo’s keynote —“Artivism and Data: Is All Art Revolutionary?”—, we explore what artivism means today: the territory where aesthetic creation stops being passive decoration to merge with open-source intelligence (OSINT), data journalism, and civic oversight.',
        'artiv.pillars.kicker': 'CONCEPTUAL MANIFESTO · QUANTUM &amp; LAB RECORDS',
        'artiv.pillars.title': 'What happens when Artivism meets Data Intelligence?',
        'artiv.pillar1.title': 'Art as Memory Technology and Trigger',
        'artiv.pillar1.desc': 'Art is not a mute object hung to match a sofa: it is a personalized sensory technology capable of triggering frequencies, catharsis, and collective memory.',
        'artiv.pillar2.title': 'Art Based on Real Facts: Aesthetics + OSINT + Oversight',
        'artiv.pillar2.desc': 'A painting or editorial cover does not need to look like a spreadsheet to contain data. Artivism merges art direction and generative cinema with public contracts, blockchain tracing, and OSINT.',
        'artiv.pillar3.title': 'From Commercial "Flexing" (3D) to Purposeful Art (Quantum)',
        'artiv.pillar3.desc': 'When art transcends ego and commercial vanity, it enters the dimension of purpose and presence. Investigating power and translating it into visual work is an act of resistance.',
        'artiv.pillar4.title': 'Total Art &amp; "The Search for Light" in Afinidades',
        'artiv.pillar4.desc': 'Under the concept of Total Art and Art Hosting at Casa Quantum (curated by Master Belarmino Miranda), traditional plastic arts converge with living AI-animated canvases and investigative journalism.',
        'artiv.archive.kicker': 'MOVING GALLERY · PROJECTABLE SITE EXPLORER',
        'artiv.archive.title': 'Living Covers, Investigations &amp; Lab Pieces',
        'artiv.archive.sub': 'Automatic carousel synchronized with the live Periodismosint archive. Click any cover to open the investigation or project its findings.',
        'author.tag': '// RESEARCHER &amp; DATA JOURNALISM',
        'author.feed.tab': 'PUBLISHED INVESTIGATIONS',
                'lernent.back': 'Back to Periodismosint',
        'lernent.unit.badge': 'Territorial Forensic Unit',
        'lernent.hero.tag': '// LAND OBSERVATORY',
        'lernent.hero.title': 'Lernent: <span class="lernent-title-accent">Land, Data &amp; Territory</span>',
        'lernent.hero.subtitle': 'Forensic investigations into land grabbing, dispossession, cadastral mapping, and corporate power networks across Latin America.',
        'lernent.badge1': 'Dispossession &amp; Restitution',
        'lernent.badge2': 'Cadastre &amp; Mining',
        'lernent.badge3': 'Corporate Power',
        'lernent.badge4': 'Socio-Environmental Conflicts',
        'lernent.callout.title': 'Investigative Journalism on Land Ownership and Soil',
        'lernent.callout.desc': 'Lernent is the specialized unit of Periodismosint dedicated to cross-referencing land registries, multispectral satellite imagery, restitution court rulings, and corporate databases to map territorial reality.',
        'lernent.feed.tab': 'TERRITORIAL INVESTIGATIONS',
        'lernent.tools.tag': '// METHODOLOGICAL CAPABILITIES',
        'lernent.tools.title': 'Cadastral &amp; Forensic Analysis Ecosystem',
        'lernent.tools.desc': 'Data tools and geolocation utilized in Lernent territorial investigations.',
        'lernent.method1.title': 'Cartography &amp; Satellite Sensors',
        'lernent.method1.desc': 'Multitemporal analysis using Sentinel-2 and Planet Labs to detect deforestation, unlawful occupation, and land-use shifts.',
        'lernent.method2.title': 'Land Registry &amp; Notarial Audits',
        'lernent.method2.desc': 'Tracing chain-of-title histories, public wasteland grants, mining concessions, and high-profile real estate transactions.',
        'lernent.method3.title': 'Corporate Structures &amp; Offshores',
        'lernent.method3.desc': 'Cross-referencing corporate holdings, trust vehicles, and ultimate beneficial owners behind land grabbing megaprojects.',
        'nav.about': 'About Us',
        'nav.support': 'Support',
        'nav.menu': 'Menu',
        'nav.subscribe': 'Subscribe',
        'nav.subscribe.placeholder': 'Your email...',
        'nav.search': 'Search Periodismosint',
        'nav.theme': 'Switch Theme',
        'nav.theme.toggle': 'Toggle Dark / Light Mode',

        // ═══════════ MOBILE MENU ═══════════
        'mobile.search': 'Search investigation...',
        'mobile.theme': '☀️ / 🌙 Dark / Light Mode',
        'mobile.sub.placeholder': 'Your email to subscribe...',
        'mobile.legal.title': 'INFORMATION & LEGAL FRAMEWORK',
        'mobile.transparency': 'Transparency →',
        'mobile.privacy': 'Privacy Policy →',
        'mobile.copy': 'Periodismosint · Data Lab & OSINT Journalism',
        'mobile.close': 'Close menu',

        // ═══════════ THANKS POPUP ═══════════
        'thanks.title': 'Thanks for joining Periodismosint!',
        'thanks.desc': 'We\'ve sent a confirmation email to your inbox. Please verify your email to complete the subscription.',
        'thanks.btn': 'Got it',

        // ═══════════ FOOTER ═══════════
        'footer.home': 'HOME',
        'footer.news': 'NEWS',
        'footer.lab': 'OSINT LAB',
        'footer.artivismo': 'ARTIVISM',
        'footer.about': 'ABOUT US',
        'footer.support': 'SUPPORT',
        'footer.transparency': 'TRANSPARENCY',
        'footer.privacy': 'PRIVACY POLICY',

        // ═══════════ FLOATING BAR ═══════════
        'float.donate.tooltip': 'Support Periodismosint ☕',
        'float.donate.aria': 'Support independent journalism',
        'float.top.aria': 'Back to top',

        // ═══════════ HOME PAGE ═══════════
        'home.hero.tagline': 'DATA · OSINT · INVESTIGATIVE JOURNALISM',
        'home.hero.hint': 'move cursor to multiply connections · click to pulse',

        // ═══════════ FEATURED SECTION ═══════════
        'featured.tab': 'FEATURED',
        'featured.badge': 'Featured',

        // ═══════════ LATEST SECTION ═══════════
        'latest.tab': 'LATEST STORIES',
        'latest.all': 'All',
        'latest.prev': 'Previous',
        'latest.next': 'Next',
        'latest.empty': 'No publications in this category yet.',

        // ═══════════ MOSAIC SECTION ═══════════
        'mosaic.tab': 'DOSSIERS & REPORTS',
        'mosaic.viewall': 'Explore all publications →',

        // ═══════════ INVESTIGATIONS SECTION ═══════════
        'inv.tab': 'INVESTIGATION LAB',
        'inv.canvas': 'Data<br>Lab',
        'inv.latest.badge': 'Periodismosint/lab — the latest',
        'inv.all.link': 'View all news →',

        // ═══════════ PILLARS SECTION ═══════════
        'pillars.tab': 'OUR PILLARS',
        'pillars.1.title': 'Data Lab',
        'pillars.1.desc': 'Investigations built on data mining and professional research methodologies.',
        'pillars.2.title': 'Current News',
        'pillars.2.desc': 'Stay informed on recent events backed by deep data analysis.',
        'pillars.3.title': 'Collaborations',
        'pillars.3.desc': 'Work with us to build strategies grounded in Big Data methodologies.',

        // ═══════════ NEWSLETTER SECTION ═══════════
        'nl.tag': 'Get to Know Us',
        'nl.title': 'Journalism that<br>needs witnesses',
        'nl.subtitle': 'Get every investigation delivered directly. No algorithms. No filters.',
        'nl.placeholder': 'email@email.com',
        'nl.btn': '[ Join ]',
        'nl.success': '✓  You\'re in! Check your email.',
        'nl.error': 'Something went wrong. Try again.',

        // ═══════════ WORKFLOW SECTION ═══════════
        'wf.tab': '// OSINT METHODOLOGY & WORKFLOW',
        'wf.title': 'From scattered data to forensic report',
        'wf.subtitle': 'Each investigation follows a rigorous, interconnected three-phase workflow, ensuring traceability and open source.',
        'wf.phase1.badge': 'PHASE 01',
        'wf.phase1.title': 'Ingestion & Open Sources',
        'wf.phase1.desc': 'Crawling public data, trade registries, satellite imagery, social listening, and secure reception of leaks.',
        'wf.phase2.badge': 'PHASE 02',
        'wf.phase2.title': 'Forensic Analysis & Cleaning',
        'wf.phase2.desc': 'Metadata validation (EXIF), photo geolocation, contractor network mapping, and Python/QGIS processing.',
        'wf.phase3.badge': 'PHASE 03',
        'wf.phase3.title': 'Publication & Open Source',
        'wf.phase3.desc': 'Publishing the journalistic report alongside raw datasets and scripts to ensure public auditability.',

        // ═══════════ SUBSCRIBE MODAL ═══════════
        'modal.close': 'Close modal',
        'modal.badge': 'STAY INFORMED',
        'modal.desc': 'What power hides, data reveals. Get our investigations unfiltered in your inbox.',
        'modal.placeholder': 'Your email address...',
        'modal.submit': 'Subscribe free',
        'modal.confirm.title': 'Important step to confirm:',
        'modal.confirm.desc': 'When you subscribe, you will receive a verification link in your inbox. Open it to activate your subscription (also check your spam folder).',
        'modal.privacy': '🔒 No spam. Cancel anytime with one click.',
        'modal.loading': 'Sending confirmation link...',
        'modal.success': '📩 Check your email! Click the link we sent to confirm your subscription.',
        'modal.error': '⚠️ Please enter a valid email address.',

        // ═══════════ SEARCH MODAL ═══════════
        'search.placeholder': 'Search investigation, data, OSINT...',
        'search.close': 'Close search',
        'search.badge': '// OSINT SEARCH ENGINE',
        'search.status': 'Type to see results with images...',
        'search.instructions': 'Type any term to search investigations, news, lab reports and journalistic articles.',
        'search.reset.instructions': 'Search investigations, publications, team members, topics, or portal sections.',
        'search.author.fallback.tag': 'AUTHOR / INVESTIGATOR',
        'search.author.fallback.bio': 'Periodismosint team investigator.',
        'search.tag.prefix': 'Topic: ',
        'search.tag.badge': 'OSINT TAG',
        'search.tag.fallback': 'Explore all publications classified under ',
        'search.post.fallback.tag': 'PUBLICATION',
        'search.results.singular': ' result found',
        'search.results.plural': ' results found',
        'search.noresults.prefix': 'No results found for "',
        'search.noresults.suffix': '". Try other terms.',
        'search.col.publications': '// PUBLICATIONS & INVESTIGATIONS (',
        'search.col.content': '// CONTENT & PUBLICATIONS (',
        'search.col.empty': 'No matching publications.',
        'search.col.team': '// TEAM, ARTISTS & CREATORS (',

        // Curated team entries in search
        'search.team.jossi.tag': 'VISUAL DIRECTION & COVER ART',
        'search.team.jossi.bio': 'Visual designer and multidisciplinary artist. Leads the aesthetics, covers, and development of new digital narratives at Periodismosint.',
        'search.team.isabela.tag': 'VISUAL ARTIST & ILLUSTRATOR',
        'search.team.isabela.bio': 'Visual artist and cover illustrator for Periodismosint\'s graphic identity (ISUARIAH).',
        'search.team.okey.tag': 'VISUAL STUDIO & COVER ART',
        'search.team.okey.bio': 'Creative studio and visual collective (SMILE YOU\'RE OKEY) collaborating on Periodismosint covers and graphics.',
        'search.team.nestor.tag': 'INVESTIGATOR & EDITORIAL DIRECTOR',
        'search.team.nestor.bio': 'OSINT investigator, specialist in open-source intelligence analysis and civil liberties.',
        'search.team.tobias.tag': 'DATA ANALYST & SEO SPECIALIST',
        'search.team.tobias.bio': 'Data analyst and web optimization for the Periodismosint team.',

        // Curated section entries in search
        'search.section.lab.title': 'OSINT Lab',
        'search.section.lab.tag': 'MAIN SECTION',
        'search.section.lab.bio': 'Open-source intelligence lab, data mining, and transparency analysis.',
        'search.section.archive.title': 'Publication Archive',
        'search.section.archive.tag': 'NEWS ARCHIVE',
        'search.section.archive.bio': 'Explore all investigations, specials, and in-depth reports from Periodismosint.',
        'search.section.about.title': 'About Us & Team',
        'search.section.about.tag': 'MEET THE TEAM',
        'search.section.about.bio': 'Profiles of our investigators, visual designers, and work methodology.',
        'search.section.support.title': 'Support & Sustainability',
        'search.section.support.tag': 'MEMBERSHIP & DONATIONS',
        'search.section.support.bio': 'Community support models to ensure independent data journalism.',
        'search.section.transparency.title': 'Transparency & Editorial Principles',
        'search.section.transparency.tag': 'ETHICAL FRAMEWORK',
        'search.section.transparency.bio': 'Declaration of independence, source protection, and Lab governance.',

        // ═══════════ LABORATORIO PAGE ═══════════
        'lab.hero.tag': 'DATA LAB',
        'lab.hero.title': 'Data. <span>Truth.</span><br>Impact.',
        'lab.hero.subtitle': 'Investigations combining data mining, open-source intelligence, and rigorous verification to expose what others can\'t see.',
        'lab.hero.btn1': 'Methodologies',
        'lab.hero.btn2': 'Tools',
        'lab.hero.btn3': 'Experiments',

        'lab.clicker.title': 'DATA PROCESSOR',
        'lab.clicker.offline': 'OFFLINE',
        'lab.clicker.online': 'ONLINE',
        'lab.clicker.processed': 'data processed',
        'lab.clicker.hint': 'click on a cluster',
        'lab.clicker.clusters': 'clusters',
        'lab.clicker.largest': 'largest batch',
        'lab.clicker.streak': 'streak',
        'lab.clicker.data': ' data',

        'lab.featured.tab': 'Featured',
        'lab.featured.badge': 'Featured',

        'lab.archive.tag': 'LAB PUBLICATIONS',
        'lab.archive.title': 'Investigations & Publications',
        'lab.archive.all': 'All',
        'lab.archive.loading': 'Loading investigations…',
        'lab.archive.viewall': 'View all →',
        'lab.archive.empty': 'No publications in this category yet.',

        'lab.method.tag': 'METHODOLOGY',
        'lab.method.title': 'How we investigate',
        'lab.method.step1.title': 'Open sources',
        'lab.method.step1.desc': 'Public records, official databases, social media, and leaked documents as the starting point.',
        'lab.method.step2.title': 'Data mining',
        'lab.method.step2.desc': 'We process large volumes of data to identify patterns, anomalies, and connections invisible to the naked eye.',
        'lab.method.step3.title': 'Verification',
        'lab.method.step3.desc': 'Every piece of data goes through at least two independent sources. Without documentary corroboration, it doesn\'t get published.',
        'lab.method.step4.title': 'Publication',
        'lab.method.step4.desc': 'Right of reply for those involved, open sources, and transparent methodology published alongside each story.',

        'lab.tools.tag': 'TOOLS',
        'lab.tools.title': 'What we work with',
        'lab.tools.1.title': 'Open Sources',
        'lab.tools.1.desc': 'Public records, official databases, digital archives, and government repositories as the base layer of every investigation.',
        'lab.tools.1.badge': 'OSINT · Investigation',
        'lab.tools.2.title': 'OSINT Industries',
        'lab.tools.2.desc': 'Digital investigation suite for geolocation, online identity analysis, infrastructure tracking, and cross-platform profile correlation.',
        'lab.tools.2.badge': 'OSINT · Digital identity',
        'lab.tools.3.title': 'Multiburo',
        'lab.tools.3.desc': 'Corporate information lookup, trade registries, and business links across Latin America. Essential for tracking ownership structures and trusts.',
        'lab.tools.3.badge': 'Corporate · Latin America',
        'lab.tools.4.title': 'DDoSecrets',
        'lab.tools.4.desc': 'Leak journalism repository and public interest data. Source of structured datasets on governments, corporations, and power groups.',
        'lab.tools.4.badge': 'Leaks · Public data',
        'lab.tools.5.title': 'Social Listening',
        'lab.tools.5.desc': 'Real-time social media, forum, and digital platform monitoring to detect emerging narratives, misinformation, and public opinion trends.',
        'lab.tools.5.badge': 'Monitoring · Social media',

        'lab.carousel.tag': 'EXPLORE THE LAB STORIES',
        'lab.carousel.title': 'Investigation Carousel',
        'lab.carousel.viewall': 'View full laboratory →',
        'lab.carousel.empty': 'No investigations available in the carousel yet.',

        'lab.cta.tag': 'COLLABORATE WITH US',
        'lab.cta.title': 'Have a lead?',
        'lab.cta.desc': 'If you have information, documents, or a story that can\'t go untold, we want to know.',

        // ═══════════ NOSOTROS PAGE ═══════════
        'about.hero.tag': 'ABOUT US',
        'about.hero.title': 'Investigative journalism<br><em>where others can\'t reach</em>',
        'about.hero.subtitle': 'Open-source intelligence (OSINT), forensic data mining, and verification at the service of truth in Latin America.',

        'about.pillar1.title': 'Independence',
        'about.pillar1.desc': 'NO ADVERTISERS OR POLITICAL AFFILIATIONS',
        'about.pillar2.title': 'Open Methodology',
        'about.pillar2.desc': 'WE PUBLISH THE CODE AND THE STEPS',
        'about.pillar3.title': 'Free Access',
        'about.pillar3.desc': 'NO PAYWALLS OR BARRIERS',
        'about.pillar4.title': 'Forensic Rigor',
        'about.pillar4.desc': 'TECHNICAL SOURCE VERIFICATION',

        'about.mission.tag': 'OUR MISSION',
        'about.mission.title': 'Data at the service of <em>truth</em>',
        'about.mission.p1': 'Periodismosint is a data, OSINT, and digital intelligence lab focused on dismantling influence operations, tracking corruption in the public sector, and defending fundamental freedoms in Latin America.',
        'about.mission.p2': 'We combine open-source tracking, forensic data mining, satellite imagery analysis, and social listening to build investigations with documentary evidence that others cannot silence.',
        'about.mission.quote': 'A rigorous investigation doesn\'t close the conversation; it opens it to public audit.',
        'about.mission.tag1': 'Open Source',
        'about.mission.tag2': 'Free Access',
        'about.mission.tag3': 'OSINT',
        'about.mission.tag4': 'Latin America',

        'about.team.tag': 'INVESTIGATION & DIRECTION',
        'about.team.title': 'Editorial & Creative Direction',
        'about.team.subtitle': 'Investigators, designers, and analysts at the forefront of the lab.',

        'about.nestor.role': 'FOUNDER & LEAD INVESTIGATOR',
        'about.nestor.bio': 'Investigation journalist and historian specializing in open-source intelligence (OSINT), digital surveillance analysis, and civil liberties in Latin America. He leads the editorial and investigative direction of the lab.',
        'about.nestor.tag1': 'OSINT Investigation',
        'about.nestor.tag2': 'Digital Surveillance',
        'about.nestor.tag3': 'Civil Liberties',

        'about.jossi.role': 'CREATIVE DIRECTOR, DEVELOPMENT & MULTIDISCIPLINARY ARTIST',
        'about.jossi.bio': 'Visual designer and multidisciplinary artist. Leads the aesthetics and development of new digital narratives at Periodismosint.',
        'about.jossi.tag1': 'Creative Direction',
        'about.jossi.tag2': 'Web Development',
        'about.jossi.tag3': 'Multidisciplinary Art',

        'about.tobias.role': 'DATA ANALYST & SEO SPECIALIST',
        'about.tobias.bio': 'Data Analyst and SEO Specialist expert in web optimization, data analysis, and digital strategy for the Periodismosint team.',
        'about.tobias.tag1': 'Data Analysis',
        'about.tobias.tag2': 'SEO Specialist',
        'about.tobias.tag3': 'Web Strategy',

        'about.art.tag': 'ART DIRECTION & CREATORS',
        'about.art.title': 'Artists & Visual Art',
        'about.art.subtitle': 'The creative talent shaping the graphic universe of Periodismosint.',
        'about.art.isabela.role': 'VISUAL ARTIST',
        'about.art.isabela.cta': 'View Instagram →',
                'about.art.okey.role': 'VISUAL STUDIO',
        'about.art.okey.cta': 'View Linktree →',
        'about.allies.tag': '// MEDIA &amp; STRATEGIC ALLIANCES',
        'about.allies.title': 'Allied Media &amp; Research Network',
        'about.allies.subtitle': 'Media outlets, data labs, and research platforms we collaborated with on investigative projects.',
        'about.allies.visit': 'Visit Platform &rarr;',

        // ═══════════ PUBLICACIONES PAGE ═══════════
        'pub.hero.brand': 'PERIODISMOSINT',
        'pub.hero.title': 'News',
        'pub.hero.subtitle': 'Data · OSINT · Investigative Journalism',
        'pub.hero.hint': 'hover · click to propagate',
        'pub.featured.tab': 'Featured',
        'pub.featured.badge': 'Featured',
        'pub.archive.title': 'Publication Archive',
        'pub.archive.subtitle': 'Investigations, OSINT analyses, and journalistic articles in chronological order.',

        // ═══════════ APOYA PAGE ═══════════
        'support.hero.tag': 'EDITORIAL FREEDOM',
        'support.hero.title': 'Independent journalism exists <em class="apoya-title-red">because you make it possible</em>',
        'support.hero.subtitle': 'No corporate advertisers, no government agendas, and no paywalls. Our investigative work is funded through voluntary community support.',
        'support.channels.tag': 'DIRECT CONTRIBUTIONS',
        'support.channels.title': 'Choose how to support this lab',
        'support.channels.subtitle': 'Every contribution has a direct and immediate impact on our ability to fund fieldwork and forensic data analysis.',
        'support.kofi.tag': 'ONE-TIME DONATION / MEMBERSHIP',
        'support.kofi.title': 'Ko-fi Contribution',
        'support.kofi.desc': 'Support with any amount, whenever you can. No forced subscriptions. Your contribution funds 100% OSINT tools and fieldwork.',
        'support.kofi.btn': 'Donate on Ko-fi →',
        'support.member.tag': 'DIRECT RECURRING SUPPORT',
        'support.member.title': 'Member Subscription',
        'support.member.desc': 'Monthly support is the backbone of this lab. It allows us to plan long-term investigations with absolute independence. Cancel anytime.',
        'support.member.btn': 'Become a Member →',
        'support.guarantee.title': 'Continental Transparency Commitment',
        'support.guarantee.desc': 'All resources received are exclusively allocated to funding server infrastructure, digital intelligence software licenses, field investigation logistics, and honorariums for independent investigators across the Americas.',

        
        
                // ═══════════ TRANSPARENCIA PAGE (ENGLISH) ═══════════
        'trans.hero.tag': '// GOVERNANCE, ETHICS &amp; TRANSPARENCY',
        'trans.hero.title': 'Transparency &amp; Editorial Principles',
        'trans.hero.subtitle': 'Learn about our governance structure, journalistic independence, sustainability model, OSINT Lab methodological rigor, and our non-negotiable commitment to source protection.',
        'trans.meta.entity': '<strong>Holding Entity:</strong> Lernent SAS · Medellín, Colombia',
        'trans.meta.focus': '<strong>Focus:</strong> Data Journalism &amp; OSINT Intelligence',
        'trans.meta.contact': '<strong>Ethical Contact:</strong> <a href="mailto:periodismosint@proton.me" class="priv-link">periodismosint@proton.me</a>',
        'trans.intro.p1': '<strong>Periodismosint</strong> (operated by <strong>Lernent SAS</strong> in Medellín, Colombia) is an independent media outlet and data research lab focused on in-depth journalism, open-source intelligence (OSINT), digital surveillance, and civil liberties.',
        'trans.intro.p2': 'Our mission is to make large volumes of public information understandable, expose power networks, and defend citizens\' right to access truth through verifiable and rigorous investigations.',
        'trans.s1.title': '1. Editorial Independence Declaration',
        'trans.s1.p1': 'At Periodismosint, editorial criteria respond solely to public interest and investigative rigor. No advertiser, sponsor, donor, government, or political party exercises control or veto over the topics we investigate, the sources we consult, or the findings we publish.',
        'trans.s1.p2': 'Our journalists and researchers work free from conflicts of interest. Any strategic alliance or institutional collaboration is made public transparently.',
        'trans.s2.title': '2. Financing &amp; Sustainability Model',
        'trans.s2.desc': 'We believe in journalism that is free and open to all, supported directly by the community. Our economic model is founded on:',
        'trans.s2.item1': '<strong>Voluntary Memberships &amp; Subscriptions:</strong> Contributions from readers who value independent data journalism.',
        'trans.s2.item2': '<strong>Consulting Activities:</strong> Consulting services provided through Lernent SAS, owner entity of the lab, channeling resources toward sustaining our investigative work.',
        'trans.s2.item3': '<strong>Research Grants &amp; Subsidies:</strong> International funds dedicated to strengthening civil liberties, human rights, and press freedom.',
        'trans.s2.item4': '<strong>Specialized Training &amp; Workshops:</strong> Training in OSINT methodologies, data mining, and digital security developed by our team.',
        'trans.s2.item5': '<strong>Social Contract Research:</strong> Non-confidential technical reports whose methodology is shared openly with the community.',
        'trans.s2.p2': 'We do not accept government funding that compromises our investigative autonomy.',
        'trans.s3.title': '3. OSINT Lab Methodological Rigor',
        'trans.s3.desc': 'Every publication produced by our <strong>Data Lab</strong> follows a strict verification protocol:',
        'trans.s3.item1': '<strong>Multi-Source Corroboration:</strong> Every finding must be backed by at least two independent sources or verifiable public documentary evidence (contracts, corporate registries, official databases, metadata, or satellite tracking).',
        'trans.s3.item2': '<strong>Data Transparency:</strong> Alongside our publications, we attach anonymized structured datasets, links to primary sources, and methodological explanations to allow auditing by other researchers or citizens.',
        'trans.s3.item3': '<strong>Peer Technical Review:</strong> Prior to dissemination, each report undergoes cross-review of code, data mining, and investigative logic by specialists on the team.',
        'trans.s3.callout': '<strong>🔒 Absolute Source Confidentiality (Art. 74 Political Constitution of Colombia):</strong> In strict compliance with Professional Journalistic Secrecy guaranteed by the Constitution of Colombia and international human rights treaties, Periodismosint will maintain absolute confidentiality over the identity of its confidential sources under all circumstances.',
        'trans.s4.title': '4. Corrections &amp; Right of Reply Protocol',
        'trans.s4.desc': 'We take responsibility for our work. When a factual error is identified or brought to our attention:',
        'trans.s4.item1': 'We rectify the information with maximum speed within the publication itself.',
        'trans.s4.item2': 'We add an explicit note at the end of the article detailing the date and exact nature of the correction made.',
        'trans.s4.item3': 'We guarantee the right of reply with at least 48 hours advance notice to persons or entities mentioned prior to publishing high-impact disclosures.',
        'trans.s5.title': '5. Secure Contact &amp; Leak Channels',
        'trans.s5.desc': 'If you have documents, datasets, or public interest leads that should be investigated, we have confidential channels available:',
        'trans.s5.item1': '<strong>Encrypted Secure Email (ProtonMail):</strong> <a href="mailto:periodismosint@proton.me">periodismosint@proton.me</a>',
        'trans.s5.item2': '<strong>Institutional Contact:</strong> <a href="mailto:lernent04@gmail.com">lernent04@gmail.com</a>',
        'trans.s5.item3': '<strong>Operating Entity:</strong> Lernent SAS · Medellín, Colombia (Law 1581 of 2012 Data Protection)',

        // ═══════════ PRIVACY POLICY PAGE (ENGLISH) ═══════════
        'privacy.hero.tag': '// LEGAL FRAMEWORK AND TRANSPARENCY',
        'privacy.hero.title': 'Privacy Policy',
        'privacy.hero.subtitle': 'All information collected during your visit to this site will be regulated under this Privacy Policy. Please read it carefully before browsing our website.',
        'privacy.meta.entity': '<strong>Holder:</strong> Lernent SAS · Medellín, Colombia',
        'privacy.meta.law': '<strong>Applicable Law:</strong> Law 1581 of 2012',
        'privacy.meta.contact': '<strong>Contact:</strong> <a href="mailto:lernent04@gmail.com" class="priv-link">lernent04@gmail.com</a>',
        'privacy.intro.p1': '<strong>periodismosint.xyz</strong>, owned by <strong>Lernent SAS</strong>, based in Medellín, Colombia, in compliance with Law 1581 of 2012, is responsible for the processing of Personal Data collected and has established a Personal Data Processing Policy and Procedures.',
        'privacy.intro.p2': 'The mechanisms through which we use this data are secure and confidential, as we possess suitable technological means to ensure they are stored in a manner that prevents unauthorized access by third parties. Likewise, we ensure complete confidentiality.',
        'privacy.intro.p3': 'During your visit, we may collect two types of information on our website: automatically collected data and information voluntarily provided by you. It will be conducted as follows:',
        'privacy.s1.title': 'A. Information you voluntarily provide',
        'privacy.s1.p1': 'We will store the information you voluntarily provide (including your name, email address, age, and interests) at various moments: (1) when registering on <em>periodismosint.xyz</em>, (2) when creating your profile, (3) when participating in our initiatives, (4) when subscribing to our newsletters and alerts, (5) when commenting on our stories, or in email surveys.',
        'privacy.s1.p2': 'The purpose of this data processing is to customize our site according to your interests and design new stories, projects, specials, and sections for readers like you. We want to know who the users are who wish to join our community and contribute content to guarantee high quality standards.',
        'privacy.s1.p3': 'We assume you provide this information voluntarily. If you prefer not to supply this information, you will still have access to our content but will not be able to interact actively with the registered user community by leaving comments.',
        'privacy.s2.title': 'B. Automatically generated information',
        'privacy.s2.p1': 'We may also collect and store information generated automatically as you navigate our site. This is done so that <em>periodismosint.xyz</em> can directly address the needs of our users.',
        'privacy.s2.p2': 'Like almost all websites, we collect cookies and computer identifications accessing our page. These cookies do not identify users personally, only their computers. They show us when and how users visit <em>periodismosint.xyz</em>, helping us understand usage patterns while saving you time by memorizing preferences.',
        'privacy.s2.p3': 'If you prefer, you may disable cookies on your computer and still access our information. However, this will prevent you from enjoying personalized advantages available to other users.',
        'privacy.s2.p4': 'We may also count the number of users visiting our page or opening newsletters. Our servers automatically collect information about your computer connection to the Internet, including your IP address. We use the IP address —which does not identify users personally— to deliver stories and measure web traffic.',
        'privacy.s3.title': 'Purposes of Data Processing',
        'privacy.s3.desc': 'Personal Data collected voluntarily or involuntarily by <em>periodismosint.xyz</em> will be used for the following purposes:',
        'privacy.s3.item1': 'Your Personal Data will be included in one or more databases and may be transmitted and/or transferred between <em>periodismosint.xyz</em> and Authorized Entities for processing according to established purposes.',
        'privacy.s3.item2': 'Achieve efficient communication with the Data Owner regarding publications, newsletters, alliances, events, announcements, and training workshops.',
        'privacy.s3.item3': 'Provide our journalistic services, investigative content, and reports.',
        'privacy.s3.item4': 'Inform about changes in our services, applicable terms, or policies.',
        'privacy.s3.item5': 'Fulfill obligations contracted with clients, suppliers, and collaborators.',
        'privacy.s3.item6': 'Evaluate service quality and the public impact of our investigations.',
        'privacy.s3.item7': 'Deliver targeted information and measure content affinity for user profiling.',
        'privacy.s3.item8': 'Compile anonymized statistical information for traffic analysis and research.',
        'privacy.s4.title': 'What do we commit to?',
        'privacy.s4.desc': '<em>periodismosint.xyz</em> commits to storing all collected information on our website in a high-security database accessible only to <em>periodismosint.xyz</em> and strategic third-party partners in specific cases.',
        'privacy.s4.callout': '<strong>🔒 Journalistic Source Confidentiality:</strong> <em>periodismosint.xyz</em> commits to maintaining absolute confidentiality regarding information for journalistic investigations provided confidentially via email or forms, and will not reveal sources under any circumstances.',
        'privacy.s5.title': 'How to exercise your rights or check for changes?',
        'privacy.s5.desc': 'You may exercise your rights to access, update, rectify Personal Data, or file inquiries and claims under Law 1581 of 2012 through official channels:',
        'privacy.s5.item1': '<strong>Official Email:</strong> <a href="mailto:lernent04@gmail.com">lernent04@gmail.com</a>',
        'privacy.s5.item2': '<strong>Responsible Entity:</strong> Lernent SAS · Medellín, Colombia',

        // ═══════════ POST TEMPLATES ═══════════
        'post.by': 'BY ',
        'post.share': 'Share',
        'post.toc': 'TABLE OF CONTENTS',
        'post.tags': 'TAGS:',
        'post.writtenby': 'WRITTEN BY',
        'post.lang_notice': '🌐 This article is originally published in Spanish.',
        'post.zoom.cover': '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg><span>Expand cover</span>',
        'post.art.credit': '🎨 <strong>Art &amp; Visual Direction:</strong> Jossi Barbosa / Periodismosint Ecosystem',
        'stream.next': 'NEXT INVESTIGATION',
        'stream.read_now': 'Read now',
        'stream.auto_transition': 'Transitioning to next story in <strong id="psint-timer-count">12</strong>s',
        'stream.pause': '✕ Pause',
        'stream.read.btn': 'Read full investigation',
        'stream.loading': 'Loading full article automatically...',
        'stream.end.title': 'Explore more in the Periodismosint Ecosystem',
        'stream.end.desc': 'Discover all network investigations, the Lernent land observatory files, or access the OSINT lab tools.',
        'stream.btn.all': 'All Publications',
        'stream.btn.lab': 'OSINT Lab',
        'stream.btn.lernent': 'Lernent Land Observatory',
    };

    // ── SPANISH FALLBACK DICTIONARY (for switching BACK to Spanish) ──
        var PSINT_DICT_ES = {
        // NAVIGATION
        'nav.home': 'Inicio',
        'nav.news': 'Noticias',
        'nav.lab': 'Laboratorio OSINT',
        'nav.lernent': 'Lernent',
        'author.tag': '// INVESTIGADOR &amp; PERIODISMO DE DATOS',
        'author.feed.tab': 'INVESTIGACIONES PUBLICADAS',
                'lernent.back': 'Volver a Periodismosint',
        'lernent.unit.badge': 'Unidad Forense Territorial',
        'lernent.hero.tag': '// OBSERVATORIO DE TIERRAS',
        'lernent.hero.title': 'Lernent: <span class="lernent-title-accent">Tierras, Datos &amp; Territorio</span>',
        'lernent.hero.subtitle': 'Investigaciones forenses sobre concentración de tierras, despojo, cartografía catastral y redes corporativas de poder en Colombia y América Latina.',
        'lernent.badge1': 'Despojo &amp; Restitución',
        'lernent.badge2': 'Catastro &amp; Minería',
        'lernent.badge3': 'Poder Corporativo',
        'lernent.badge4': 'Conflictos Socioambientales',
        'lernent.callout.title': 'Periodismo de Investigación sobre la Propiedad y el Suelo',
        'lernent.callout.desc': 'Lernent es la unidad especializada de Periodismosint dedicada a cruzar folios de matrícula inmobiliaria, imágenes satelitales multiespectrales, sentencias de restitución y bases de datos corporativas para mapear la verdad territorial.',
        'lernent.feed.tab': 'INVESTIGACIONES TERRITORIALES',
        'lernent.tools.tag': '// CAPACIDADES METODOLÓGICAS',
        'lernent.tools.title': 'Ecosistema de Análisis Catastral &amp; Forense',
        'lernent.tools.desc': 'Herramientas de datos y geolocalización utilizadas en las investigaciones territoriales de Lernent.',
        'lernent.method1.title': 'Cartografía &amp; Sensores Satelitales',
        'lernent.method1.desc': 'Análisis multitemporal con Sentinel-2 y Planet Labs para detectar deforestación, ocupación indebida y cambios en el uso del suelo.',
        'lernent.method2.title': 'Auditoría Registral &amp; Notarial',
        'lernent.method2.desc': 'Rastreo de cadenas de tradición, títulos baldíos, licencias mineras y transacciones inmobiliarias de alto perfil.',
        'lernent.method3.title': 'Estructuras Corporativas &amp; Offshores',
        'lernent.method3.desc': 'Cruce de holdings, sociedades fiduciarias y beneficiarios finales detrás de megaproyectos y acaparamiento de tierras.',
        'nav.about': 'Nosotros',
        'nav.support': 'Apoya',
        'nav.menu': 'Menú',
        'nav.subscribe': 'Suscribirme',
        'nav.subscribe.placeholder': 'Tu email...',
        'nav.search': 'Buscar en Periodismosint',
        'nav.theme': 'Cambiar Tema',
        'nav.theme.toggle': 'Conmutar Modo Oscuro / Claro',

        // MOBILE MENU
        'mobile.search': 'Buscar investigación...',
        'mobile.theme': '☀️ / 🌙 Modo Oscuro / Claro',
        'mobile.sub.placeholder': 'Tu email para suscribirte...',
        'mobile.legal.title': 'INFORMACIÓN & MARCO LEGAL',
        'mobile.transparency': 'Transparencia →',
        'mobile.privacy': 'Política de Privacidad →',
        'mobile.copy': 'Periodismosint · Laboratorio de Datos & Periodismo OSINT',
        'mobile.close': 'Cerrar menú',

        // THANKS POPUP
        'thanks.title': '¡Gracias por unirte a Periodismosint!',
        'thanks.desc': 'Te hemos enviado un correo de confirmación a tu bandeja de entrada. Por favor verifica tu email para completar la suscripción.',
        'thanks.btn': 'Entendido',

        // FOOTER
        'footer.home': 'INICIO',
        'footer.news': 'NOTICIAS',
        'footer.lab': 'LABORATORIO OSINT',
        'footer.about': 'NOSOTROS',
        'footer.support': 'APOYA',
        'footer.transparency': 'TRANSPARENCIA',
        'footer.privacy': 'POLÍTICA DE PRIVACIDAD',

        // FLOATING BAR
        'float.donate.tooltip': 'Apoya Periodismosint ☕',
        'float.donate.aria': 'Apoyar periodismo independiente',
        'float.top.aria': 'Volver arriba',

        // HOME PAGE
        'home.hero.tagline': 'DATOS · OSINT · PERIODISMO DE INVESTIGACIÓN',
        'home.hero.hint': 'mueve el cursor para multiplicar conexiones · clic para pulsar',

        // FEATURED SECTION
        'featured.tab': 'DESTACADOS',
        'featured.badge': 'Destacado',

        // LATEST SECTION
        'latest.tab': 'ÚLTIMAS NOTAS',
        'latest.all': 'Todos',
        'latest.prev': 'Anterior',
        'latest.next': 'Siguiente',
        'latest.empty': 'No hay publicaciones en esta categoría aún.',

        // MOSAIC SECTION
        'mosaic.tab': 'EXPEDIENTES & REPORTAJES',
        'mosaic.viewall': 'Explorar todas las publicaciones →',

        // INVESTIGATIONS SECTION
        'inv.tab': 'LABORATORIO DE INVESTIGACIONES',
        'inv.canvas': 'Laboratorio<br>de Datos',
        'inv.latest.badge': 'Periodismosint/lab &mdash; lo último',
        'inv.all.link': 'Ver todas las noticias &rarr;',

        // PILLARS SECTION
        'pillars.tab': 'NUESTROS PILARES',
        'pillars.1.title': 'Laboratorio de Datos',
        'pillars.1.desc': 'Investigaciones basadas en minería de datos y metodologías de investigación profesional.',
        'pillars.2.title': 'Noticias actuales',
        'pillars.2.desc': 'Mantente informado de hechos recientes con el respaldo de análisis de datos profundos.',
        'pillars.3.title': 'Colaboraciones',
        'pillars.3.desc': 'Trabaja con nosotros para construir estrategias basadas en metodologías de Big Data.',

        // NEWSLETTER SECTION
        'nl.tag': 'Conócenos',
        'nl.title': 'Periodismo que<br>necesita testigos',
        'nl.subtitle': 'Recibe cada investigación directamente. Sin algoritmos. Sin filtros.',
        'nl.placeholder': 'correo@correo.com',
        'nl.btn': '[ Unirme ]',
        'nl.success': '✓  ¡Estás dentro! Revisa tu correo.',
        'nl.error': 'Algo salió mal. Intenta de nuevo.',

        // WORKFLOW SECTION
        'wf.tab': '// METODOLOGÍA OSINT & WORKFLOW',
        'wf.title': 'De datos dispersos a informe forense',
        'wf.subtitle': 'Cada investigación sigue un flujo de trabajo riguroso de tres fases interconectadas, asegurando trazabilidad y código abierto.',
        'wf.phase1.badge': 'FASE 01',
        'wf.phase1.title': 'Ingesta & Fuentes Abiertas',
        'wf.phase1.desc': 'Rastreo masivo en fuentes abiertas (OSINT), repositorios públicos, registros corporativos y monitoreo de redes.',
        'wf.phase2.badge': 'FASE 02',
        'wf.phase2.title': 'Minería & Análisis Forense',
        'wf.phase2.desc': 'Procesamiento de datos no estructurados, correlación de identidades, análisis satelital y verificación de hechos.',
        'wf.phase3.badge': 'FASE 03',
        'wf.phase3.title': 'Publicación & Transparencia',
        'wf.phase3.desc': 'Redacción periodística con estándar forense, liberación de conjuntos de datos y preservación de fuentes.',

        // SUBSCRIBE MODAL
        'modal.close': 'Cerrar modal',
        'modal.badge': 'MANTENTE INFORMADO',
        'modal.title': 'Periodismo sin filtros ni concesiones',
        'modal.desc': 'Lo que el poder oculta, los datos lo revelan. Recibe nuestras investigaciones sin filtro en tu bandeja.',
        'modal.placeholder': 'Tu dirección de correo electrónico...',
        'modal.submit': 'Suscribirme gratis',
        'modal.confirm.title': 'Paso importante para confirmar:',
        'modal.confirm.desc': 'Al suscribirte, recibirás un enlace de acceso en tu bandeja de entrada. Ábrelo para validar tu cuenta (revisa también tu carpeta de spam).',
        'modal.privacy': '🔒 Sin spam. Cancela cuando quieras con un solo clic.',
        'modal.loading': 'Enviando enlace de confirmación...',
        'modal.success': '📩 ¡Revisa tu correo! Haz clic en el enlace que te enviamos para confirmar tu suscripción.',
        'modal.error': '⚠️ Por favor ingresa un correo electrónico válido.',

        // SEARCH MODAL
        'search.placeholder': 'Buscar investigación, datos, OSINT...',
        'search.close': 'Cerrar búsqueda',
        'search.badge': '// MOTOR DE BÚSQUEDA OSINT',
        'search.status': 'Escribe para ver resultados con imágenes...',
        'search.instructions': 'Escribe cualquier término para buscar investigaciones, noticias, informes del laboratorio y artículos periodísticos.',
        'search.noresults': 'No se encontraron investigaciones para "%s"',
        'search.count': '%s resultados encontrados',

        // LABORATORIO PAGE
        'lab.hero.tag': 'LABORATORIO DE DATOS',
        'lab.hero.title': 'Inteligencia de fuentes abiertas<br><em>&amp; periodismo de datos</em>',
        'lab.hero.subtitle': 'Desarrollamos herramientas, metodologías y minería de datos para revelar patrones invisibles, rastrear operaciones de influencia y auditar el poder en América Latina.',
        'lab.hero.btn1': 'Metodologías',
        'lab.hero.btn2': 'Herramientas',
        'lab.hero.btn3': 'Experimentos',

        'lab.clicker.title': 'PROCESADOR DE DATOS',
        'lab.clicker.processed': 'datos procesados',
        'lab.clicker.hint': 'haz click en un cluster',
        'lab.clicker.clusters': 'clusters',
        'lab.clicker.largest': 'mayor lote',
        'lab.clicker.streak': 'racha',

        'lab.featured.tab': 'Destacados',
        'lab.featured.badge': 'Destacado',

        'lab.archive.tag': 'PUBLICACIONES DEL LABORATORIO',
        'lab.archive.title': 'Investigaciones &amp; Publicaciones',
        'lab.archive.all': 'Todas',
        'lab.archive.loading': 'Cargando investigaciones…',
        'lab.archive.viewall': 'Ver todos →',

        'lab.method.tag': 'METODOLOGÍA',
        'lab.method.title': 'Cómo investigamos',
        'lab.method.step1.title': 'Fuentes abiertas',
        'lab.method.step1.desc': 'Rastreamos registros públicos, bases de datos gubernamentales, documentos corporativos y huellas digitales usando técnicas OSINT avanzadas.',
        'lab.method.step2.title': 'Minería de datos',
        'lab.method.step2.desc': 'Procesamos grandes volúmenes de datos para identificar patrones, anomalías y conexiones invisibles a simple vista.',
        'lab.method.step3.title': 'Verificación',
        'lab.method.step3.desc': 'Cada dato pasa por al menos dos fuentes independientes. Sin corroboración documental, no se publica.',
        'lab.method.step4.title': 'Publicación',
        'lab.method.step4.desc': 'Derecho de réplica a los involucrados, código abierto de nuestras fuentes y metodología transparente junto a cada historia.',

        'lab.tools.tag': 'HERRAMIENTAS',
        'lab.tools.title': 'Con qué trabajamos',
        'lab.tools.1.title': 'Fuentes Abiertas',
        'lab.tools.1.desc': 'Registros públicos, bases de datos oficiales, archivos digitales y repositorios gubernamentales como capa base de cada investigación.',
        'lab.tools.1.badge': 'OSINT · Investigación',
        'lab.tools.2.title': 'OSINT Industries',
        'lab.tools.2.desc': 'Suite de investigación digital para geolocalización, análisis de identidad digital, rastreo de infraestructura y correlación de perfiles.',
        'lab.tools.2.badge': 'OSINT · Identidad digital',
        'lab.tools.3.title': 'Multiburo',
        'lab.tools.3.desc': 'Consulta de información corporativa, registros mercantiles y vinculaciones empresariales en América Latina. Esencial para rastrear propiedad.',
        'lab.tools.3.badge': 'Corporativo · América Latina',
        'lab.tools.4.title': 'DDoSecrets',
        'lab.tools.4.desc': 'Repositorio de periodismo de filtraciones y datos de interés público. Fuente de conjuntos de datos sobre gobiernos y corporaciones.',
        'lab.tools.4.badge': 'Filtraciones · Datos públicos',
        'lab.tools.5.title': 'Escucha Social',
        'lab.tools.5.desc': 'Monitoreo en tiempo real de redes sociales, foros y plataformas digitales para detectar narrativas emergentes y desinformación.',
        'lab.tools.5.badge': 'Monitoreo · Redes sociales',

        'lab.carousel.tag': 'EXPLORA LAS HISTORIAS DEL LAB',
        'lab.carousel.title': 'Carrusel de Investigaciones',
        'lab.carousel.viewall': 'Ver laboratorio completo →',
        'lab.carousel.empty': 'No hay investigaciones disponibles en el carrusel aún.',

        'lab.cta.tag': 'COLABORA CON NOSOTROS',
        'lab.cta.title': '¿Tienes una punta?',
        'lab.cta.desc': 'Si tienes información, documentos o una historia que no se puede quedar sin contar, queremos saberlo.',

        // NOSOTROS PAGE
        'about.hero.tag': 'NOSOTROS',
        'about.hero.title': 'Periodismo de investigación<br><em>donde otros no llegan</em>',
        'about.hero.subtitle': 'Inteligencia de fuentes abiertas (OSINT), minería forense de datos y verificación al servicio de la verdad en América Latina.',

        'about.pillar1.title': 'Independencia',
        'about.pillar1.desc': 'SIN ANUNCIANTES NI FILIACIÓN POLÍTICA',
        'about.pillar2.title': 'Metodología Abierta',
        'about.pillar2.desc': 'PUBLICAMOS EL CÓDIGO Y LOS PASOS',
        'about.pillar3.title': 'Acceso Libre',
        'about.pillar3.desc': 'SIN PAYWALLS NI BARRERAS',
        'about.pillar4.title': 'Rigor Forense',
        'about.pillar4.desc': 'VERIFICACIÓN TÉCNICA DE FUENTES',

        'about.mission.tag': 'NUESTRA MISIÓN',
        'about.mission.title': 'Datos al servicio de la <em>verdad</em>',
        'about.mission.p1': 'Periodismosint es un laboratorio de datos, OSINT e inteligencia digital dedicado a desmantelar operaciones de influencia, rastrear la corrupción en el sector público y defender las libertades fundamentales en América Latina.',
        'about.mission.p2': 'Combinamos el rastreo en fuentes abiertas, la minería forense de datos, el análisis de imágenes satelitales y la escucha social para construir investigaciones con prueba documental que otros no pueden callar.',
        'about.mission.quote': 'Una investigación rigurosa no cierra la conversación; la abre a la auditoría pública.',
        'about.mission.tag1': 'Código Abierto',
        'about.mission.tag2': 'Acceso Libre',
        'about.mission.tag3': 'OSINT',
        'about.mission.tag4': 'América Latina',

        'about.team.tag': 'INVESTIGACIÓN &amp; DIRECCIÓN',
        'about.team.title': 'Dirección Editorial &amp; Creativa',
        'about.team.subtitle': 'Investigadores, diseñadores y analistas al frente del laboratorio.',

        'about.nestor.role': 'FUNDADOR &amp; INVESTIGADOR PRINCIPAL',
        'about.nestor.bio': 'Periodista de investigación e historiador especializado en inteligencia de fuentes abiertas (OSINT), análisis de vigilancia digital y libertades civiles en América Latina. Dirige la línea editorial e investigativa del laboratorio.',
        'about.nestor.tag1': 'Investigación OSINT',
        'about.nestor.tag2': 'Vigilancia Digital',
        'about.nestor.tag3': 'Libertades Civiles',

        'about.jossi.role': 'DIRECTOR CREATIVO, DESARROLLO &amp; ARTISTA MULTIDISCIPLINAR',
        'about.jossi.bio': 'Diseñador visual y artista multidisciplinar. Dirige la estética, las portadas y el desarrollo de nuevas narrativas digitales en Periodismosint.',
        'about.jossi.tag1': 'Dirección Creativa',
        'about.jossi.tag2': 'Desarrollo Web',
        'about.jossi.tag3': 'Arte Multidisciplinar',

        'about.tobias.role': 'ANALISTA DE DATOS &amp; ESPECIALISTA SEO',
        'about.tobias.bio': 'Analista de Datos y Especialista SEO experto en optimización web, análisis de datos y estrategia digital para el equipo de Periodismosint.',
        'about.tobias.tag1': 'Análisis de Datos',
        'about.tobias.tag2': 'Especialista SEO',
        'about.tobias.tag3': 'Estrategia Web',

        'about.art.tag': 'DIRECCIÓN DE ARTE &amp; CREADORES',
        'about.art.title': 'Artistas &amp; Arte Visual',
        'about.art.subtitle': 'El talento creativo que da forma al universo gráfico de Periodismosint.',
        'about.art.isabela.role': 'ARTISTA VISUAL',
        'about.art.isabela.cta': 'Ver Instagram →',
                'about.art.okey.role': 'ESTUDIO VISUAL',
        'about.art.okey.cta': 'Ver Linktree →',
        'about.allies.tag': '// MEDIOS Y ALIANZAS ESTRATÉGICAS',
        'about.allies.title': 'Ecosistema de Redes &amp; Medios Aliados',
        'about.allies.subtitle': 'Medios de comunicación, laboratorios de datos y plataformas de investigación con los que hemos colaborado y desarrollado investigaciones.',
        'about.allies.visit': 'Visitar Medio &rarr;',

        // PUBLICACIONES PAGE
        'pub.hero.brand': 'PERIODISMOSINT',
        'pub.hero.title': 'Noticias',
        'pub.hero.subtitle': 'Datos · OSINT · Periodismo de investigación',
        'pub.hero.hint': 'hover · click para propagar',
        'pub.featured.tab': 'Destacados',
        'pub.featured.badge': 'Destacado',
        'pub.archive.title': 'Archivo de Publicaciones',
        'pub.archive.subtitle': 'Investigaciones, análisis OSINT y artículos periodísticos en orden cronológico.',

        // APOYA PAGE
        'support.hero.tag': 'LIBERTAD EDITORIAL',
        'support.hero.title': 'El periodismo independiente existe <em class="apoya-title-red">porque tú lo haces posible</em>',
        'support.hero.subtitle': 'Sin anunciantes corporativos, sin agendas gubernamentales y sin muros de pago. Nuestro trabajo de investigación se financia a través del apoyo voluntario de la comunidad.',
        'support.channels.tag': 'APORTES DIRECTOS',
        'support.channels.title': 'Elige cómo apoyar este laboratorio',
        'support.channels.subtitle': 'Cada aporte tiene un impacto directo e inmediato en nuestra capacidad para financiar trabajo de campo y análisis forense de datos.',
        'support.kofi.tag': 'DONACIÓN PUNTUAL / MEMBRESÍA',
        'support.kofi.title': 'Aporte vía Ko-fi',
        'support.kofi.desc': 'Apoya con la cifra que desees, cuando puedas. Sin suscripciones forzadas. Tu aporte financia 100% herramientas OSINT y trabajo de campo.',
        'support.kofi.btn': 'Donar en Ko-fi →',
        'support.member.tag': 'APOYO RECURRENTE DIRECTO',
        'support.member.title': 'Suscripción de Miembro',
        'support.member.desc': 'El apoyo mensual es la columna vertebral de este laboratorio. Nos permite planificar investigaciones a largo plazo con absoluta independencia. Cancela cuando quieras.',
        'support.member.btn': 'Ser Miembro →',
        'support.guarantee.title': 'Compromiso de Transparencia Continental',
        'support.guarantee.desc': 'Todos los recursos recibidos se destinan exclusivamente a financiar infraestructura de servidores, licencias de software de inteligencia digital, logística de investigación de campo y honorarios de investigadores independientes en las Américas.',

        // TRANSPARENCIA PAGE
        'trans.hero.tag': '// GOBERNANZA, ÉTICA &amp; TRANSPARENCIA',
        'trans.hero.title': 'Transparencia &amp; Principios Editoriales',
        'trans.hero.subtitle': 'Conoce nuestra estructura de gobernanza, independencia periodística, modelo de sostenibilidad, rigor metodológico del Laboratorio OSINT y nuestro compromiso innegociable con la protección de fuentes.',
        'trans.meta.entity': 'Entidad Titular: Lernent SAS · Medellín, Colombia',
        'trans.meta.focus': 'Enfoque: Periodismo de Datos &amp; Inteligencia OSINT',
        'trans.meta.contact': 'Contacto Ético:',
        'trans.intro.p1': 'Periodismosint es una plataforma independiente de periodismo de datos, OSINT e inteligencia digital operada bajo la sombrilla legal de Lernent SAS, sociedad constituida en Medellín, Colombia, y dedicada al desarrollo de proyectos de comunicación digital e innovación editorial.',
        'trans.intro.p2': 'Este documento establece nuestros lineamientos editoriales y éticos innegociables, nuestro modelo de sostenibilidad, nuestra metodología de verificación y nuestro compromiso férreo con la protección de fuentes.',
        'trans.s1.title': '1. Declaración de Independencia Editorial',
        'trans.s1.p1': 'Periodismosint no tiene filiación con partidos políticos, gobiernos, grupos corporativos, fundaciones u ONGs de ninguna índole. La línea editorial la determina exclusivamente el equipo de investigación basándose en criterios de interés público, impacto social potencial y disponibilidad de evidencia documental.',
        'trans.s1.p2': 'Ningún anunciante, patrocinador o donante tiene ni tendrá jamás injerencia en nuestras decisiones editoriales. Nuestras historias no están a la venta.',
        'trans.s2.title': '2. Modelo de Financiamiento &amp; Sostenibilidad',
        'trans.s2.desc': 'Sostenemos nuestra operación mediante una combinación de:',
        'trans.s2.item1': 'Donaciones individuales voluntarias (Ko-fi, PayPal, cripto).',
        'trans.s2.item2': 'Membresías de apoyo voluntario sin contenido exclusivo (sin paywalls).',
        'trans.s2.item3': 'Consultoría estratégica para organizaciones de periodismo de investigación y análisis de datos.',
        'trans.s2.item4': 'Becas y fondos de defensa del periodismo (sin interferencia editorial).',
        'trans.s2.item5': 'Alianzas éticas con medios de comunicación y organizaciones enfocadas en OSINT.',
        'trans.s3.title': '3. Rigor Metodológico del Laboratorio OSINT',
        'trans.s3.item1': 'Toda publicación pasa por al menos una doble verificación independiente (dos fuentes distintas o documentación complementaria).',
        'trans.s3.item2': 'Aplicamos protocolos OSINT (Open Source Intelligence): análisis de imágenes satelitales, datos EXIF, registros corporativos, expedientes judiciales y escucha social automatizada cuando es legalmente procedente.',
        'trans.s3.item3': 'Publicamos el workflow metodológico de cada investigación, permitiendo al lector auditar el proceso de análisis.',
        'trans.s3.callout': '🔒 Reserva de Fuentes Absoluta (Art. 74, Constitución Política de Colombia): Bajo ninguna circunstancia revelaremos la identidad de ninguna fuente que haya entregado información bajo condición de anonimato. Este principio es innegociable y constitucionalmente protegido.',
        'trans.s4.title': '4. Protocolo de Correcciones &amp; Derecho de Réplica',
        'trans.s4.item1': 'Si se identifica un error de hecho tras la publicación, se emitirá una corrección visible con fecha, texto original y versión corregida en un plazo máximo de 48 horas.',
        'trans.s4.item2': 'Toda persona o entidad mencionada en una investigación será contactada para solicitar su versión antes de publicar. Si declina responder, se dejará constancia en el artículo.',
        'trans.s4.item3': 'Recibimos comentarios de nuestros lectores a través de nuestros canales de contacto. Las críticas constructivas nos ayudan a mejorar.',
        'trans.s5.title': '5. Canales de Contacto Seguro &amp; Filtraciones',

        // PRIVACY POLICY PAGE
        'privacy.hero.tag': '// MARCO LEGAL Y TRANSPARENCIA',
        'privacy.hero.title': 'Política de Privacidad',
        'privacy.hero.subtitle': 'Toda la información recabada durante su visita a este sitio estará regulada por la presente Política de Privacidad y las leyes aplicables de la República de Colombia.',
        'privacy.meta.entity': 'Titular: Lernent SAS · Medellín, Colombia',
        'privacy.meta.law': 'Ley Aplicable: Ley 1581 de 2012',
        'privacy.meta.contact': 'Contacto:',
        'privacy.section.a.title': 'A. Información que usted suministra voluntariamente',
        'privacy.section.b.title': 'B. Información generada automáticamente',
        'privacy.purposes.title': 'Finalidades del Tratamiento de Datos',
        'privacy.commitment.title': '¿A qué nos comprometemos?',
        'privacy.sources.title': '🔒 Reserva de Fuentes Periodísticas',
        'privacy.rights.title': '¿Cómo ejercer sus derechos o verificar cambios?',

        // POST TEMPLATES
        'post.by': 'POR ',
        'post.readtime.1': '1 min de lectura',
        'post.readtime.n': '% min de lectura',
        'post.share': 'Compartir',
        'post.share.copied': 'Copiado',
        'post.toc': 'ÍNDICE DE CONTENIDO',
        'post.disclaimer': 'Periodismosint es un medio independiente investigado, redactado y verificado por periodistas humanos. Nuestro contenido se crea para personas reales, no para crawlers de IA ni algoritmos. Suscríbete aquí para apoyar el periodismo de investigación sin censura.',
        'post.tags': 'ETIQUETAS:',
        'post.writtenby': 'ESCRITO POR',
        'post.related.title': '// MÁS HISTORIAS &amp; INVESTIGACIONES',
        'post.related.viewall': 'Ver todo el archivo →',
                'post.zoom.cover': '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg><span>Ampliar portada</span>',
        'post.art.credit': '🎨 Arte &amp; Dirección Visual: Jossi Barbosa / Ecosistema Periodismosint',
        'post.guest.role': 'COLABORADOR / AUTOR INVITADO',

        // PAGINATION
        'pagination.prev': '← Anterior',
        'pagination.page': 'Página',
        'pagination.of': 'de',
        'pagination.next': 'Siguiente →',

        // LIGHTBOX
        'lightbox.alt': 'Ampliado',
        'lightbox.close': 'Cerrar',

        // RELATIVE DATES
        'time.year': ' año',
        'time.years': ' años',
        'time.month': ' mes',
        'time.months': ' meses',
        'time.day': ' día',
        'time.days': ' días',
        'time.hour': ' hora',
        'time.hours': ' horas',
        'time.minute': ' minuto',
        'time.minutes': ' minutos',
        'time.moment': 'hace un momento',
        'time.ago': 'hace ',

        // MONTHS
        'months': ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],

        // STREAM CONTINUOUS READING
        'stream.next': 'SIGUIENTE INVESTIGACIÓN',
        'stream.read_now': 'Leer ahora',
        'stream.auto_transition': 'Pasando a la siguiente historia en <strong id="psint-timer-count">12</strong>s',
        'stream.pause': '✕ Pausar',
        'stream.read.btn': 'Leer investigación completa',
        'stream.loading': 'Cargando artículo completo automáticamente...',
        'stream.end.title': 'Explora más en el Ecosistema Periodismosint',
        'stream.end.desc': 'Descubre todas las investigaciones de la red, los expedientes del observatorio Lernent o accede a las herramientas del laboratorio OSINT.',
        'stream.btn.all': 'Todas las Publicaciones',
        'stream.btn.lab': 'Laboratorio OSINT',
        'stream.btn.lernent': 'Lernent Tierras',

        // LANG TOGGLE BUTTON
        'lang.toggle.label': 'EN',
        'lang.toggle.mobile': '🌐 English'
    };

    // ── ENGINE ─────────────────────────────────────────────────────────
    var currentLang = localStorage.getItem('psint_lang') || 'es';

    function getDictionary(lang) {
        return lang === 'en' ? PSINT_DICT : PSINT_DICT_ES;
    }

        function applyTranslations(lang) {
        var dict = getDictionary(lang);

        // 1. data-i18n (textContent)
        document.querySelectorAll('[data-i18n]').forEach(function(el) {
            var key = el.getAttribute('data-i18n');
            if (el.__initial_es_text === undefined) {
                el.__initial_es_text = el.textContent;
            }
            if (lang === 'es') {
                el.textContent = dict[key] !== undefined ? dict[key] : el.__initial_es_text;
            } else if (dict[key] !== undefined) {
                el.textContent = dict[key];
            }
        });

        // 2. data-i18n-html (innerHTML — for text with <em>, <span>, <br>)
        document.querySelectorAll('[data-i18n-html]').forEach(function(el) {
            var key = el.getAttribute('data-i18n-html');
            if (el.__initial_es_html === undefined) {
                el.__initial_es_html = el.innerHTML;
            }
            if (lang === 'es') {
                el.innerHTML = dict[key] !== undefined ? dict[key] : el.__initial_es_html;
            } else if (dict[key] !== undefined) {
                el.innerHTML = dict[key];
            }
        });

        // 3. data-i18n-placeholder
        document.querySelectorAll('[data-i18n-placeholder]').forEach(function(el) {
            var key = el.getAttribute('data-i18n-placeholder');
            if (el.__initial_es_ph === undefined) {
                el.__initial_es_ph = el.getAttribute('placeholder') || '';
            }
            if (lang === 'es') {
                el.setAttribute('placeholder', dict[key] !== undefined ? dict[key] : el.__initial_es_ph);
            } else if (dict[key] !== undefined) {
                el.setAttribute('placeholder', dict[key]);
            }
        });

        // 4. data-i18n-aria (aria-label)
        document.querySelectorAll('[data-i18n-aria]').forEach(function(el) {
            var key = el.getAttribute('data-i18n-aria');
            if (el.__initial_es_aria === undefined) {
                el.__initial_es_aria = el.getAttribute('aria-label') || '';
            }
            if (lang === 'es') {
                el.setAttribute('aria-label', dict[key] !== undefined ? dict[key] : el.__initial_es_aria);
            } else if (dict[key] !== undefined) {
                el.setAttribute('aria-label', dict[key]);
            }
        });

        // 5. data-i18n-title
        document.querySelectorAll('[data-i18n-title]').forEach(function(el) {
            var key = el.getAttribute('data-i18n-title');
            if (el.__initial_es_title === undefined) {
                el.__initial_es_title = el.getAttribute('title') || '';
            }
            if (lang === 'es') {
                el.setAttribute('title', dict[key] !== undefined ? dict[key] : el.__initial_es_title);
            } else if (dict[key] !== undefined) {
                el.setAttribute('title', dict[key]);
            }
        });

        // 6. Update <html lang>
        document.documentElement.setAttribute('lang', lang === 'en' ? 'en' : 'es');

        // 7. Update segmented toggle active state
        document.querySelectorAll('.psint-lang-opt').forEach(function(btn) {
            if (btn.getAttribute('data-lang') === lang) {
                btn.classList.add('is-active');
            } else {
                btn.classList.remove('is-active');
            }
        });
        document.querySelectorAll('.psint-mobile-lang-opt').forEach(function(btn) {
            if (btn.getAttribute('data-lang') === lang) {
                btn.classList.add('is-active');
            } else {
                btn.classList.remove('is-active');
            }
        });

        
        // 9. Dual-Language Post Content Swapping (.lang-es / .lang-en)
        var postContainer = document.querySelector('.psint-post-content-body');
        if (postContainer) {
            var esBlocks = postContainer.querySelectorAll('.lang-es, [data-lang="es"]');
            var enBlocks = postContainer.querySelectorAll('.lang-en, [data-lang="en"]');
            var noticeEl = document.getElementById('psint-post-lang-notice');

            if (enBlocks.length > 0) {
                if (lang === 'en') {
                    esBlocks.forEach(function(b) { b.style.display = 'none'; });
                    enBlocks.forEach(function(b) { b.style.display = 'block'; });
                    if (noticeEl) noticeEl.style.display = 'none';
                } else {
                    esBlocks.forEach(function(b) { b.style.display = 'block'; });
                    enBlocks.forEach(function(b) { b.style.display = 'none'; });
                    if (noticeEl) noticeEl.style.display = 'none';
                }
            } else if (lang === 'en') {
                if (noticeEl) noticeEl.style.display = 'flex';
            } else {
                if (noticeEl) noticeEl.style.display = 'none';
            }
        }

        // 8. Dispatch custom event for JS components (dates, search, etc.)
        window.dispatchEvent(new CustomEvent('psint:langchange', { detail: { lang: lang } }));
    }

    function setLanguage(lang) {
        currentLang = lang;
        localStorage.setItem('psint_lang', lang);
        applyTranslations(lang);
    }

    function toggleLanguage() {
        setLanguage(currentLang === 'es' ? 'en' : 'es');
    }

    // ── PUBLIC API ──────────────────────────────────────────────────────
    window.PSINT_I18N = {
        setLanguage: setLanguage,
        toggleLanguage: toggleLanguage,
        getCurrentLang: function() { return currentLang; },
        t: function(key) {
            var dict = getDictionary(currentLang);
            return dict[key] !== undefined ? dict[key] : key;
        },
        getDictES: function() { return PSINT_DICT_ES; },
        getDictEN: function() { return PSINT_DICT; }
    };

    // ── AUTO-APPLY on DOM ready ─────────────────────────────────────────
    if (currentLang !== 'es') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                applyTranslations(currentLang);
            });
        } else {
            applyTranslations(currentLang);
        }
    }

    // ── Bind toggle buttons ─────────────────────────────────────────────
    document.addEventListener('DOMContentLoaded', function() {
        // Desktop & Mobile Segmented Switcher clicks
        document.addEventListener('click', function(e) {
            var opt = e.target.closest('.psint-lang-opt, .psint-mobile-lang-opt');
            if (opt) {
                var targetLang = opt.getAttribute('data-lang');
                if (targetLang) {
                    setLanguage(targetLang);
                }
            } else if (e.target.closest('#psint-lang-switcher')) {
                toggleLanguage();
            }
        });

        // Theme Toggle Handler for Desktop and Mobile Icon Buttons
        document.addEventListener('click', function(e) {
            var themeBtn = e.target.closest('#psint-theme-toggle, #psint-mobile-theme-toggle');
            if (themeBtn) {
                var currentTheme = document.documentElement.getAttribute('data-theme') || 'light';
                var nextTheme = currentTheme === 'dark' ? 'light' : 'dark';
                document.documentElement.setAttribute('data-theme', nextTheme);
                localStorage.setItem('psint_theme', nextTheme);
                // Swap home hero logo for dark/light modes
                swapHeroLogo(nextTheme);
            }
        });

        // Logo swap helper: dark → white logo, light → dark logo
        function swapHeroLogo(theme) {
            var LOGO_LIGHT = 'https://i.imgur.com/fVutFS3.png';
            var LOGO_DARK  = 'https://i.imgur.com/I3yf1wn.png';
            var heroLogos = document.querySelectorAll('.psint-home-hero-logo');
            heroLogos.forEach(function(img) {
                img.src = (theme === 'dark') ? LOGO_DARK : LOGO_LIGHT;
            });
        }

        // Apply logo on initial load
        (function() {
            var savedTheme = localStorage.getItem('psint_theme') || 'light';
            swapHeroLogo(savedTheme);
        })();

        // Re-apply if user returns to page (bfcache)
        window.addEventListener('pageshow', function(event) {
            if (event.persisted) {
                var savedLang = localStorage.getItem('psint_lang') || 'es';
                if (savedLang !== 'es') {
                    applyTranslations(savedLang);
                }
            }
        });
    });

})();
